import { z } from 'zod';

export function looksLikeValidHostnameForUrl(hostname: string): boolean {
  const ipv4 = hostname.match(/^(\d{1,3})(?:\.(\d{1,3})){3}$/);
  if (ipv4) {
    const parts = hostname.split('.').map((p) => Number(p));
    return parts.length === 4 && parts.every((n) => Number.isInteger(n) && n >= 0 && n <= 255);
  }

  const parts = hostname.split('.').filter(Boolean);
  if (parts.length < 2) return false;
  const tld = parts[parts.length - 1];
  if (!tld) return false;
  return /^[a-zA-Z]{2,}$/.test(tld);
}

type UrlMessages = {
  required?: string;
  invalid?: string;
  mustBeHttps?: string;
  invalidDomain?: string;
};

export function zHttpsUrlWithValidHostname(messages?: UrlMessages) {
  return z
    .string()
    .trim()
    .min(1, messages?.required ?? 'URL requise')
    .url(messages?.invalid ?? 'URL invalide')
    .superRefine((val, ctx) => {
      let parsed: URL | null = null;
      try {
        parsed = new URL(val);
      } catch {
        return;
      }

      if (parsed.protocol !== 'https:') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: messages?.mustBeHttps ?? "L'URL doit commencer par https://",
        });
      }

      if (!looksLikeValidHostnameForUrl(parsed.hostname)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            messages?.invalidDomain ??
            'Le domaine doit être valide (ex: https://exemple.com/webhook)',
        });
      }
    });
}
